import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetConfigurationDictionariesQuery } from '../../store/dictionaries/service';
import { useLazyGetTariffsValidatorQuery } from './store/services';

import { TariffsRoutes } from '../../routes';

import cn from './tariffs.module.css';

const Tariffs = (): React.JSX.Element => {
  const navigate = useNavigate();
  const match = useMatch(TariffsRoutes.TARIFFS);

  const { activePermissions, riskScoreRanges } = useAppSelector(
    (state) => state.configurationDictionaries,
  );

  const [getDictionaries] = useLazyGetConfigurationDictionariesQuery();
  const [getValidators] = useLazyGetTariffsValidatorQuery();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.SECTION_FEE_TARIFFS) &&
      activePermissions.includes(PermissionEnum.TARIFFS_LIST)
    ) {
      if (!riskScoreRanges) {
        getDictionaries();
      }

      getValidators();
      if (match) {
        navigate(TariffsRoutes.TARIFFS_LIST);
      }
    }
  }, [match, activePermissions, riskScoreRanges]);

  useEffect(() => {
    let title = 'Tariffs';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.tariffsLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_FEE_TARIFFS) ||
      !activePermissions.includes(PermissionEnum.TARIFFS_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.tariffs}>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default Tariffs;
